export default "__VITE_ASSET__8$hcAaoU__"